import { useMutation } from '@tanstack/react-query';

import { prophetTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const toggleProphetPage: prophetTypes.ToggleProphetPage = (data) => {
  const { pageId, isEnabled } = data;
  if (isEnabled) {
    return axios.post(`/prophet/pages/disable`, { pageId });
  }
  return axios.post(`/prophet/pages/enable`, { pageId });
};

type ToggleProphetPageOptions = {
  config?: MutationConfig<typeof toggleProphetPage>;
};

export function useToggleProphetPage({ config = {} }: ToggleProphetPageOptions = {}) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['prophet-pages']);
      queryClient.invalidateQueries(['prophet-page']);
      queryClient.invalidateQueries(['prophet-page-audit']);
    },
    ...config,
    mutationFn: toggleProphetPage,
  });
}
